import React from 'react'
import { Switch, Route, BrowserRouter } from 'react-router-dom'

import Login from './pages/Login'
import Dashboard from './pages/Dashboard'

const Router = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path={'/'} component={Login} />
      <Route exact path={'/dashboard'} component={Dashboard} />
    </Switch>
  </BrowserRouter>
)

export default Router



// WEBPACK FOOTER //
// ./src/components/Router.js